import { map, prop } from 'ramda';

var extractFieldNames = map(prop('internalName'));

function SharePointListAdapter(
    siteUrl,
    listId,
    relListUrl,
    fields,
    sortBy,
    sortAsc,
) {
    var fieldNames = extractFieldNames(fields);

    this.fields = fields;
    this.fieldNames = fieldNames;
    this.siteURL = siteUrl;
    this.listId = listId;
    this.relListUrl = relListUrl;
    this.sortBy = sortBy;
    this.sortAsc = sortAsc;
}

export default SharePointListAdapter;
